import React from 'react';
import { BoxProps } from '@apia/theme';
import useContext from '../../../../../hooks/useContext';
import { dataGridActions } from '../../../../../store/dataGridSlice/dataGridSlice';
import makeKeyHandler from '../../../../../store/selection/makeKeyHandler';
import { DataGridIdentifier } from './context';

const KeyHandler = (props: BoxProps) => {
  const { gridId } = useContext(DataGridIdentifier);

  const Handler = React.useMemo(
    () =>
      makeKeyHandler(dataGridActions, gridId, {
        throttleOptions: { wait: 50 },
        stateSelector: (global) => global.dataGridSlice[gridId],
      }),
    [gridId],
  );

  return <Handler {...props} />;
};

export default React.memo(KeyHandler);
